<template>
    <div class="preview-dialog" v-if="isShow" @click="onClose">
        <div class="agreement-container" @click.stop="" @touchmove.stop="">
            <van-icon class="close-btn" name="cross" @click="onClose" />
            <div class="agreement-content">
                <div v-if="agreementContent">
                    <div v-html="agreementContent" />
                    <div class="footer">
                        <div>
                            <p>甲方：</p>
                            <p>时间：</p>
                        </div>
                        <div>
                            <div class="user">
                                <p>乙方：</p>
                                <img :src="signatureBase64" />
                            </div>
                            <p>时间：</p>
                        </div>
                    </div>
                </div>
                <div v-else class="loading">
                    <van-loading color="#999" size="32px" type="spinner" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Loading } from 'vant'
import { previewAgreement } from '@/utils/api.js'

export default {
    components: { VanLoading: Loading },
    data() {
        return {
            isShow: false,

            signatureBase64: '',
            agreementContent: '',
        }
    },
    methods: {
        onShow(data) {
            this.agmData = data
            this.isShow = true
            this.previewAgreementApi()
        },
        onClose() {
            this.isShow = false
            this.$emit('onClose')
        },

        previewAgreementApi() {
            previewAgreement({
                userId: this.agmData.userId,
                archiveNo: this.agmData.archiveNo,
                productNo: this.agmData.productNo,
                productType: this.agmData.productType,
                extra: this.agmData.extra,
            }).then((res) => {
                this.agreementContent = res.data.content
                this.signatureBase64 = res.data.signatureBase64
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.preview-dialog {
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
}

.agreement-container {
    width: 720px;
    background: #fff;
    border-radius: 4px;
    padding: 20px 0;
    box-sizing: border-box;
    position: relative;
    .close-btn {
        position: absolute;
        top: 0;
        right: 0;
        padding: 16px;
        font-size: 24px;
        cursor: pointer;
    }
    .agreement-content {
        width: 100%;
        height: 560px;
        padding: 0 28px;
        box-sizing: border-box;
        overflow-y: scroll;
        .loading {
            height: 80%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .footer {
            margin: 24px 0 36px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            > div {
                width: 200px;
            }
            .user {
                display: flex;
                align-items: center;
                p {
                    flex-shrink: 0;
                }
                img {
                    height: 48px;
                    width: auto;
                    background: none;
                }
            }
        }
        ::v-deep p {
            margin: 12px 0;
            line-height: 1.5;
            font-size: 14px;
            color: #333333;
        }
    }
}

@media screen and (max-width: 900px) {
    .preview-dialog {
        align-items: flex-end;
    }
    .agreement-container {
        width: 100%;
        .agreement-content {
            width: 100%;
            height: 70vh;
        }
    }
}
</style>
